'use client';

import { Button, Dialog, DialogBackdrop, DialogPanel, TransitionChild } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import React, { useState } from 'react';

import { ReactNode } from 'react';

interface SideBarChildProps {
  onClose?: () => void;
}

interface SideBarProps {
  children: React.ReactElement<SideBarChildProps>;
  openButton: ReactNode;
  widthClasses?: string;
}

export default function SideBar({
  children,
  openButton,
  widthClasses = 'max-w-[16em]',
}: SideBarProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <>
      <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="relative z-50">
        <DialogBackdrop
          transition
          className="bg-bd-light/40 backdrop-blur-xs data-closed:opacity-0 fixed inset-0 mx-auto max-w-[1536px] transition-opacity duration-300 ease-linear"
        />

        <div className="fixed inset-0 z-10 mx-auto flex h-dvh max-w-[1536px]">
          <DialogPanel
            transition
            className={clsx(
              'data-closed:-translate-x-full relative flex h-full w-full flex-1 transform transition duration-300 ease-in-out',
              widthClasses
            )}
          >
            <div className="bg-bd-light text-bd-dark flex h-full flex-col gap-4 pb-2 shadow-xl">
              <div className="flex h-full grow flex-col space-y-2 overflow-y-auto px-4 pt-6 sm:px-8 lg:pt-8">
                <TransitionChild>
                  <Button
                    key="close"
                    onClick={() => setSidebarOpen(false)}
                    className="font-menu text-bd-primary/80 hover:text-bd-primary flex cursor-pointer items-center gap-1 font-light uppercase hover:font-normal"
                  >
                    <XMarkIcon aria-hidden="true" className="h-5 w-5" />
                    <span className="pt-[1px]">Close</span>
                  </Button>
                  {/* <div className="absolute right-2 top-0 z-20 flex w-16 justify-center pt-5 duration-300 ease-in-out data-closed:opacity-0">
                    <button
                      type="button"
                      onClick={() => setSidebarOpen(false)}
                      className="-m-2.5 p-2"
                    >
                  {React.isValidElement(children) && React.cloneElement(children, { onLinkClick: () => setSidebarOpen(false) } as SideBarChildProps)}
                      <XMarkIcon aria-hidden="true" className="h-6 w-6 text-slate-800" />
                    </button>
                  </div> */}
                  {/* TODO: This is a hack to pass the onClose function to the children JewelrySideFilters does not work when there is non-empty cart. */}
                  {React.isValidElement(children)
                    ? React.cloneElement(children, { onClose: () => setSidebarOpen(false) })
                    : children}
                </TransitionChild>
              </div>
            </div>
          </DialogPanel>
        </div>
      </Dialog>

      <div onClick={() => setSidebarOpen(true)}>{openButton}</div>
    </>
  );
}
